import styled from 'styled-components';
import { statusColors } from '../../../defaultTheme';
import Button from '../../atoms/Button';
export const MessageCard = styled.div `
  position: relative;
  display: flex;
  padding: 16px 32px 16px 16px;
  border: 1px solid
    ${({ type }) => (type ? statusColors[type].border : 'inherit')};
  border-radius: 10px;
  background-color: ${({ type }) => type ? statusColors[type].background : 'inherit'};
`;
export const MessageBody = styled.div `
  color: ${({ type }) => (type ? statusColors[type].font : 'inherit')};
  width: 100%;
`;
export const IconWrapper = styled.div `
  display: inline-block;
  text-align: center;
  margin-right: 12px;
  width: 48px;
  height: auto;
  color: ${({ type }) => (type ? statusColors[type].icon : 'inherit')};
`;
export const MessageCloseButton = styled(Button) `
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  top: 12px;
  right: 12px;
`;
